import { useEffect } from 'react';
function isAllowedFormOrigin(origin) {
  try {
    const {
      hostname
    } = new URL(origin);
    return hostname === window.location.hostname || hostname.endsWith('.hsforms.net') || hostname.endsWith('.hsformsqa.net');
  } catch (_unused) {
    return false;
  }
}
export function useFormMessageEvents(formId, dispatch) {
  useEffect(() => {
    const handleMessage = event => {
      if (!isAllowedFormOrigin(event.origin)) return;
      if (typeof event.data !== 'object' || event.data === null) return;
      const {
        type,
        id,
        eventName
      } = event.data;
      if (type === 'hsFormCallback' && id === formId) {
        dispatch(eventName);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [formId, dispatch]);
}